import { render, staticRenderFns } from "./SelectionSummary.vue?vue&type=template&id=358d63c4&scoped=true"
import script from "./SelectionSummary.vue?vue&type=script&lang=js"
export * from "./SelectionSummary.vue?vue&type=script&lang=js"
import style0 from "./SelectionSummary.vue?vue&type=style&index=0&id=358d63c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d63c4",
  null
  
)

export default component.exports